<template>
    <div>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="650" :styles="{top: '100px'}">
        <Form ref="feedbackForm" :model="feedbackForm" :label-width="70" :rules="formValidate">
            <FormItem label="审核状态" prop="content">
                <i-switch size="large" v-model="feedbackForm.isPass" :true-value="1" :false-value="2">
                    <span slot="open">通过</span>
                    <span slot="close">拒绝</span>
                </i-switch>
            </FormItem>
            <FormItem label="回复内容" prop="opinion">
                <Input v-model="feedbackForm.opinion" type="textarea" autocomplete="off"/>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="cancelUser">取消</Button>
            <Button type="primary" :loading="submitLoading" @click="handelSubmit">提交</Button>
        </div>
    </Modal>
    </div>
</template>

<script>
    import {opinion} from "@/api/bus";
    export default {
        name: "creditbankDrawer",
        components: {

        },
        data() {
            return {
                type:0,
                errorPass: "",
                deptLoading: false,
                modalTitle: "学分审核",
                submitLoading: false,
                modalVisible: false,
                feedbackForm: {
                    id:"",
                    isPass: 1,
                    opinion:""
                },
                formValidate: {
                    title: [{required: true, message: "回复内容不能为空", trigger: "blur"}]
                }
            }
        },
        methods: {
            init() {

            },
            getData() {
                this.loading = true;
                opinion(this.feedbackForm.id).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.feedbackForm = res.data;
                    }
                });
            },
            showDrawer(params) {
                this.modalVisible = true;
                if (params.id) {
                    this.type = 1;
                    this.modalTitle = "学分审核";
                    this.feedbackForm.id=params.id;
                    this.feedbackForm.opinion = params.opinion;
                }
            },
            cancelUser() {
                this.modalVisible = false;
            },
            handelSubmit() {
                this.$refs.feedbackForm.validate(valid => {
                    if (valid) {
                        this.submitLoading = true;
                        // 添加 避免编辑后传入id等数据 记得删除
                        opinion(this.feedbackForm).then(res => {
                            this.submitLoading = false;
                            if (res.status === true) {
                                this.$Message.success("添加成功");
                                this.$parent.getDataList();
                                this.modalVisible = false;
                            }
                        });
                    }
                });
            }
        },
        mounted() {

        }
    }
</script>

<style>

</style>